import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { ChangeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/change-dto';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { ServiceordreAfregningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-afregning-dto';
import { ServiceordreAfregningPostDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-afregning-post-dto';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { ServiceordreWithAfregningResponseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-with-afregning-response-dto';
import { UpdateServiceordreRequestDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/update-serviceordre-request-dto';
import { KundesegmentEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/kundesegment-enum';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { ValidationResult } from 'src/app/api/models/OK/Egis/Service/Models/validation-result';
import { ServiceAftaleService } from 'src/app/api/services';
import { AfregningslinieDialogData } from 'src/app/components/aftale/models';
import { ConfirmDialogComponent } from 'src/app/components/shared/confirm-dialog/confirm-dialog.component';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AfregningslinieeditaddComponent } from '../afregningslinieeditadd/afregningslinieeditadd.component';

@Component({
    selector: 'app-edit-ordre-details',
    templateUrl: './edit-ordre-details.component.html',
    styleUrls: ['./edit-ordre-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditOrdreDetailsComponent implements OnInit {
  @Input() set serviceordreWithAfregning(value: ServiceordreWithAfregningResponseDto) {
    this.initView(value);
  }

  private _serviceAftale: ServiceaftaleDto;
  @Input() set serviceAftale(value: ServiceaftaleDto) {
    this._serviceAftale = value;
    if (value) {
      this.isNarvarme = this.serviceAftale.kunde?.kundeExtendedInformation?.harNaervarmeAftale;
      this.isLeasing = this.serviceAftale.kunde?.kundeExtendedInformation?.harLeasingAftale;
      this.isGasfyrTryghed = this.serviceAftale.kunde?.kundeExtendedInformation?.harGasfyrTryghedAftale;
      this.isErhverv = this.serviceAftale.kunde?.kundetype?.kundeSegment == KundesegmentEnum.Erhverv;
    }
  }

  get serviceAftale() {
    return this._serviceAftale;
  }

  serviceordre: ServiceordreDto;
  serviceOrdreAfregning: ServiceordreAfregningDto;

  @Output() UpdateOrder: EventEmitter<UpdateServiceordreRequestDto> = new EventEmitter();

  dataSource = new BehaviorSubject<AbstractControl[]>([]);
  isServiceOrdreEditable: boolean = false;
  isInvoiceNoteEditable: boolean = false;
  saldo: number;
  serviceOrdreAfregningPosteringer: ServiceordreAfregningPostDto[];
  afregningAutoApprovalResult: ValidationResult;

  bemaerkningerShowing: boolean = false;

  isNarvarme: boolean = false;
  isLeasing: boolean = false;
  isGasfyrTryghed: boolean = false;
  isErhverv: boolean = false;
  expandPosteringerTabel: boolean = false;

  recentChanges: ChangeDto[];

  serviceOrdreForm: UntypedFormGroup = this.formBuilder.group({
    fakturaNote: [],
  });

  get fakturaNote() {
    return this.serviceOrdreForm.get('fakturaNote');
  }

  constructor(private formBuilder: UntypedFormBuilder, public dialog: MatDialog, private serviceaftaleService: ServiceAftaleService) {}

  ngOnInit(): void {}

  initView(serviceordreAndAfregning: ServiceordreWithAfregningResponseDto) {
    this.serviceordre = serviceordreAndAfregning.serviceOrdre;
    //Godkendt or fejlet afregning
    this.isServiceOrdreEditable =
      (this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.CompletedWithAccounting ||
        this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.InvoicingFailed ||
        this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.Broadcasted) &&
      this.serviceordre.partner.isOrderEditingAllowed;
    this.isInvoiceNoteEditable =
      this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.CompletedWithAccounting ||
      this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.InvoicingFailed ||
      this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.Broadcasted;
    this.serviceOrdreAfregning = serviceordreAndAfregning.serviceOrdreAfregning;
    this.serviceOrdreAfregningPosteringer = this.serviceOrdreAfregning?.serviceordreAfregningPostList;
    this.afregningAutoApprovalResult = serviceordreAndAfregning.afregningAutoApprovalResult;

    this.fakturaNote.setValue(serviceordreAndAfregning.serviceOrdre?.fakturaNote);

    if (!this.isInvoiceNoteEditable) {
      this.fakturaNote.disable();
    }

    this.getRecentChanges(serviceordreAndAfregning.serviceOrdre);
  }

  getRecentChanges(serviceordre: ServiceordreDto) {
    if (!serviceordre && !serviceordre.leveringsdato) return;

    this.serviceaftaleService
      .getServiceaftaleChangesForServiceordre({
        caller: EGIS_SERVICE_CALLER,
        serviceordreNo: this.serviceordre.serviceordreNo,
      })
      .pipe()
      .subscribe((recentChanges: ChangeDto[]) => {
        this.recentChanges = recentChanges;
      });
  }

  UpdateFakturaNote() {
    if (!this.serviceOrdreForm.valid || !this.serviceOrdreForm.dirty) return;
    this.serviceOrdreForm.markAsPristine();
    const request: UpdateServiceordreRequestDto = {
      serviceordreId: this.serviceordre.id,
      fakturaNote: this.fakturaNote.value,
      serviceordreAfregningPostList: this.serviceOrdreAfregningPosteringer,
    };
    this.UpdateOrder.emit(request);
  }

  addPosteringsLinje() {
    let data: AfregningslinieDialogData = {
      editMode: false,
      afregningsLinje: null,
      isNaerVarmeLeasingGasTryghed: this.isNarvarme || this.isLeasing || this.isGasfyrTryghed,
      leveringsDate: this.serviceordre.leveringsdato ? new Date(this.serviceordre.leveringsdato) : null,
    };

    const dialogRef = this.dialog.open(AfregningslinieeditaddComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let linjer = this.serviceOrdreAfregningPosteringer.slice();
        linjer.push(result);
        const request: UpdateServiceordreRequestDto = {
          serviceordreId: this.serviceordre.id,
          fakturaNote: this.fakturaNote.value,
          serviceordreAfregningPostList: linjer,
        };
        this.UpdateOrder.emit(request);
      }
    });
  }

  deleteLinje(posteringsLinie: ServiceordreAfregningPostDto) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Er du sikker?',
        body: 'Er du sikker på at du vil slette linien med produktet: ' + posteringsLinie.produkt + '?',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        let index = this.serviceOrdreAfregningPosteringer.indexOf(posteringsLinie);
        if (index >= 0) {
          let linjer = this.serviceOrdreAfregningPosteringer.slice();
          linjer.splice(index, 1);
          const request: UpdateServiceordreRequestDto = {
            serviceordreId: this.serviceordre.id,
            fakturaNote: this.fakturaNote.value,
            serviceordreAfregningPostList: linjer,
          };
          this.UpdateOrder.emit(request);
        }
      }
    });
  }

  editLinie(posteringsLinie: ServiceordreAfregningPostDto) {
    let data: AfregningslinieDialogData = {
      editMode: true,
      afregningsLinje: posteringsLinie,
      isNaerVarmeLeasingGasTryghed: this.isNarvarme || this.isLeasing || this.isGasfyrTryghed,
      leveringsDate: this.serviceordre.leveringsdato ? new Date(this.serviceordre.leveringsdato) : null,
    };

    const dialogRef = this.dialog.open(AfregningslinieeditaddComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let index = this.serviceOrdreAfregningPosteringer.indexOf(posteringsLinie);
        if (index >= 0) {
          let linjer = this.serviceOrdreAfregningPosteringer.slice();
          linjer[index] = result;
          const request: UpdateServiceordreRequestDto = {
            serviceordreId: this.serviceordre.id,
            fakturaNote: this.fakturaNote.value,
            serviceordreAfregningPostList: linjer,
          };
          this.UpdateOrder.emit(request);
        }
      }
    });
  }

  linierChanged(posteringsLinier: ServiceordreAfregningPostDto[]) {
    this.serviceOrdreAfregningPosteringer = posteringsLinier;

    const request: UpdateServiceordreRequestDto = {
      serviceordreId: this.serviceordre.id,
      fakturaNote: this.fakturaNote.value,
      serviceordreAfregningPostList: this.serviceOrdreAfregningPosteringer,
    };
    this.UpdateOrder.emit(request);
  }

  get visBemaerkninger() {
    return this.serviceordre.tags.length || this.visManuelGodkendelse || this.recentChanges?.length > 0;
  }

  get visManuelGodkendelse() {
    return (
      this.serviceordre.serviceordreStateEnum == ServiceordreStatusEnum.CompletedWithAccounting &&
      !this.afregningAutoApprovalResult?.isValid
    );
  }
}
